module.exports = __webpack_public_path__ + "img/applyOverseaen.cc3ee00e.jpg";